<div class="resolve-loader" *ngIf="loading">
  <img src="assets/images/loadingIcon.svg" class="loading-icon" />
  Loading...
</div>
